import { z } from 'zod';
import { EmailSchema, LangCodeSchema, TimestampSchema, UuidSchema } from './primitives';

/** Shape of a row from the shared `users` table (one user can belong to multiple tenants). */
export const UserSchema = z.object({
  id: UuidSchema,
  email: EmailSchema,
  display_name: z.string().min(1).max(120).nullable(),
  avatar_url: z.string().url().nullable(),
  preferred_lang: LangCodeSchema,
  created_at: TimestampSchema,
  updated_at: TimestampSchema,
});
export type User = z.infer<typeof UserSchema>;

export const UpdateUserInputSchema = z
  .object({
    display_name: z.string().min(1).max(120).nullable(),
    avatar_url: z.string().url().nullable(),
    preferred_lang: LangCodeSchema,
  })
  .partial();
export type UpdateUserInput = z.infer<typeof UpdateUserInputSchema>;
